export default function Mailto({ email, subject = '', body = '', children }) {
    let params = subject || body ? '?' : '';
    if (subject) params += `subject=${encodeURIComponent(subject)}`;
    if (body) params += `${subject ? '&' : ''}body=${encodeURIComponent(body)}`;

    return <a style={{width: "100%", height: "100%", display: "flex", alignItems: "center",}} href={`mailto:${email}${params}`}>{children}</a>;
};